import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './WhatsAppFloat.css';

function WhatsAppFloat() {
  const phone = '543436114146'; 
  const message = encodeURIComponent(
    'Hola, quisiera consultar por sus soluciones de software.'
  );

  return (
    <a
      href={`https://wa.me/${phone}?text=${message}`}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      title="Contactar por WhatsApp"
    >
      <FaWhatsapp />
    </a>
  );
}

export default WhatsAppFloat;